import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

import { table } from '../components/shared/tables';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';

import { throwError } from 'rxjs/internal/observable/throwError';

@Injectable({
  providedIn: 'root'
})
export class CrudService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService
  ) { }

  // Agregar objeto nuevo (nuevo registro)
  public addObjc(data, table, prnt?) {
    let path;
    let objStr = JSON.stringify(data);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table}", "prnt":${prnt},"objc":${objStr}}`)
    objStr = encodeURIComponent(objStr);
    if (prnt !== undefined) {
      path =
        this._apiRestService.APIURL.serv8 + `/{"tble":"${table}", "prnt":${prnt},"objc":${objStr}}`;
    }
    else {
      path = this._apiRestService.APIURL.serv8 + `/{"tble":"${table}","objc":${objStr}}`;
    }

    return this.http
      .get(path)
      .pipe(
        map((res: any) => {
          return res;
        })
      );
  }

  //  Consulta datos para datatable (datos principales)
  getData(table) {
    return this.http
      .get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table}"}`)
      .pipe(
        map((res: Response) => {
          let dataUser = { data: res };
          return dataUser;
        })
      );
  }

  // Consulta por padre detalle completo (prnt)
  public getDataDetalle(prnt, table) {
    return this.http
      .get(
        this._apiRestService.APIURL.serv6 +
        `/{"tble":"${table}","type":"meta","objc":{"prnt":"${prnt}"}}`
      )
      .pipe(
        map((res: Response) => {
          return res;
        })
      );
  }

  // Eliminar atributo de la tabla consultada, para actualizar, con objeto.
  delObj(data, table, prnt?) {
    let path;
    let objStr = JSON.stringify(data);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    objStr = encodeURIComponent(objStr);

    if (prnt !== undefined) {
      console.log('dentro if')
      path = this._apiRestService.APIURL.serv9 + `/{"tble":"${table}","prnt":${prnt},"objc":${objStr}}`;
    }
    else {
      path = this._apiRestService.APIURL.serv9 + `/{"tble":"${table}","objc":${objStr}}`;
    }
    return this.http
      .get(path)
      .pipe(
        map((res: any) => {
          let data = res;
          return data;
        })
      );
  }

  // Operación de Consolidado
  restDis(monto1, monto2) {
    monto1 - monto2;
  }

  // Define tipo de consulta (General o por unidad)
  selectFilter(opt, dvision, unidad, tabla) {
    if (opt === true) {
      return this.getData(table[tabla]);
    }
    else {
      return this.getTableUni(dvision, unidad, tabla);
    }
  }

  // Consulta por unidad/dpto (la dvsion y unidad deben ser string)
  getTableUni(dvsion, unidad, tabla) {
    let atrb;
    let valor;
    let erro = { status: 403 };

    // Buscar atributo en ocar solamente
    if (tabla === 'ocar' || tabla === 'ocarOldr' ) {
      if (dvsion === undefined) {
        return throwError(erro);
      }
      else if (dvsion[0] === undefined && unidad[0] === undefined) {
        return throwError(erro);
      }
      else if (unidad === undefined || unidad[0] === '') {
        atrb = 'unidad';
        valor = dvsion[0];
      }
      else {
        atrb = 'unidad';
        valor = unidad[0];
      }

    }
    else {
        if (dvsion === undefined && unidad === undefined) {
          return throwError(erro);
        } else if (dvsion === undefined) {
          return throwError(erro);
        } else if (unidad === undefined || unidad === '') {
          atrb = 'dvsionContraOwner';
          valor = dvsion;
        } else {
          atrb = 'unidadContraOwner';
          valor = unidad;
        }
    }

    return this.http
      .get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table[tabla]}","unit":"true"}`)
      .pipe(
        map((res: any) => res.filter(res => res[atrb] != undefined && res[atrb][0] === valor))
      );
  }

  //Servicio para modificar el estado del boton OnOff
  setOnOff(opt) {
    return this.http
      .get(this._apiRestService.APIURL.serv129 + `/{"onOffInic":"${opt}"}`)
      .pipe(
        map((res: Response) => {
          let onOff = { data: res };
          return onOff;
        })
      )
  }

  getOnOff() {
    return this.http
      .get(this._apiRestService.APIURL.serv129)
      .pipe(
        map((res: Response) => {
          let onOff = { data: res };
          return onOff;
        })
      )
  }
}
